import { PageHeader } from "@/components/shared/PageHeader";

// Simple legal/policy content shell for the foundation phase.
export default function PolicyPage({ overline, title, testId, sections = [] }) {
  return (
    <div data-testid={testId}>
      <PageHeader overline={overline} titleLines={[title]} />
      <section className="bg-white py-20 md:py-28">
        <div className="container-asai max-w-3xl">
          <p className="mb-10 text-sm text-navy/50">Last updated: December 2025</p>
          <div className="flex flex-col gap-10">
            {sections.map((s) => (
              <div key={s.heading}>
                <h2 className="font-heading text-2xl text-navy">{s.heading}</h2>
                <p className="mt-3 leading-relaxed text-navy/70">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
